export interface UnitTypeInterface {
  id: string;
  name: string;
}

export class UnitType {
  id: string;
  name: string;

  constructor(param: UnitTypeInterface = {
    id: null,
    name: null,
  }) {
    if (param) {
      this.id = param.id;
      this.name = param.name;
    }
  }
}
